if (!customElements.get('beadleaves-cart-recommendations')) {
  class BeadLeavesCartRecommendations extends HTMLElement {}
  customElements.define('beadleaves-cart-recommendations', BeadLeavesCartRecommendations);
}

(() => {
  const formatMoney = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: currency || 'USD'
  }).format(cents / 100);

  const imageUrl = (product) => {
    const image = product.featured_image || (product.images && product.images[0]);
    if (!image) return '';
    return typeof image === 'string' ? image : (image.url || image.src || '');
  };

  const renderCard = (product, root) => {
    const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
    if (!variant) return '';
    const price = Number(variant.price);
    const isEligible = root.dataset.allPricedProductsEligible === 'true' && price > 0;
    const discountPrice = price - Math.floor(price * .05);
    const discountMarkup = isEligible
      ? `<s>${formatMoney(price, root.dataset.currency)}</s><strong>${formatMoney(discountPrice, root.dataset.currency)}</strong><span class="bl-cart-rec-card__save">with 2+</span>`
      : `<strong>${formatMoney(price, root.dataset.currency)}</strong>`;
    return `<article class="bl-cart-rec-card">
      <a class="bl-cart-rec-card__image" href="${product.url}">${imageUrl(product) ? `<img src="${imageUrl(product)}&width=360" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" width="360" height="360">` : ''}</a>
      <div class="bl-cart-rec-card__body">
        <a class="bl-cart-rec-card__title" href="${product.url}">${product.title}</a>
        <div class="bl-cart-rec-card__price">${discountMarkup}</div>
        <button class="bl-cart-rec-card__add" type="button" data-variant-id="${variant.id}">Add to cart</button>
      </div>
    </article>`;
  };

  const init = async (root) => {
    if (root.dataset.loaded === 'true') return;
    root.dataset.loaded = 'true';
    const track = root.querySelector('[data-bl-recommendations-track]');
    const cartIds = root.dataset.cartProductIds.split(',').filter(Boolean);
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${root.dataset.productId}&limit=8&intent=related`);
      const payload = await response.json();
      const products = (payload.products || []).filter((product) => !cartIds.includes(String(product.id))).slice(0, 4);
      track.innerHTML = products.length ? products.map((product) => renderCard(product, root)).join('') : '';
    } catch (error) {
      track.innerHTML = '';
    }
  };

  const initAll = () => document.querySelectorAll('.bl-cart-recommendations').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.bl-cart-rec-card__add');
    if (!button) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]}) });
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try again';
    }
  });
})();
